<template>
  <component :is="progressData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="progressData === undefined">
      <h4 class="alert-heading">獲取進度數據時出錯</h4>
      <div class="alert-body">
        找不到相關進度記錄。請查看
        <b-link class="alert-link" :to="{ name: 'progress-list' }">
          進度列表
        </b-link>
      </div>
    </b-alert>
    <progress-edit-tab-information
      v-if="progressData"
      :projectOptions="projectOptions"
      :productOptions="productOptions"
      :workerOptions="workerOptions"
      :approvalStatusOptions="approvalStatusOptions"
      :progress-data="progressData"
      @refetch-data="refetchData"
      class="p-sm-2"
    />
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import progressStoreModule from "../progressStoreModule";
import progressEditTabInformation from "./progressEditTabInformation.vue";

export default {
  components: {
    progressEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const progressData = ref({ id: 0 });
    const progress = {
      id: 0,
      salary_items: [{id:0}],
      cost_items: [{id:0}],
    };

    const progress_APP_STORE_MODULE_NAME = "progress";

    if (!store.hasModule(progress_APP_STORE_MODULE_NAME))
      store.registerModule(progress_APP_STORE_MODULE_NAME, progressStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(progress_APP_STORE_MODULE_NAME))
        store.unregisterModule(progress_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "progress-create") {
        progressData.value = progress;
      } else {
        store
          .dispatch("progress/fetchProgress", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            progressData.value = response.data.progress;
            progressData.value.approve_status_id = progressData.value.approve_status_id ? progressData.value.approve_status_id : 1
          })
          .catch((error) => {
            console.log("error when fetching progress", error);
            if (error.response.status === 404) {
              progressData.value = undefined;
            }
          });
      }
    };

    const projectOptions = ref([]);
    const productOptions = ref([]);
    const workerOptions = ref([]);
    const approvalStatusOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          projects: true,
          products: true,
          workers: true,
          approve_status: true,
        })
        .then((response) => {
          projectOptions.value = response.data.projects;
          productOptions.value = response.data.products;
          workerOptions.value = response.data.workers;
          approvalStatusOptions.value = response.data.approve_statuses;

        });
    };

    onMounted(() => {
      refetchOption();
      refetchData();
    });

    return {
      refetchData,
      progressData,
      projectOptions,
      productOptions,
      workerOptions,
      approvalStatusOptions,
    };
  },
};
</script>
